import ConfigBooleanElement from './ConfigBooleanElement.vue'
import ConfigDateElement from './ConfigDateElement.vue'
import ConfigListElement from './ConfigListElement.vue'
import ConfigMultiListElement from './ConfigMultiListElement.vue'
import ConfigNumberElement from './ConfigNumberElement.vue'
import ConfigTagInputElement from './ConfigTagInputElement.vue'
import ConfigTextElement from './ConfigTextElement.vue'
import ConfigTimeElement from './ConfigTimeElement.vue'

export const CONFIG_DYNAMIC_ELEMENTS = {
  1: ConfigTextElement,
  2: ConfigTextElement,
  3: ConfigNumberElement,
  4: ConfigListElement,
  7: ConfigDateElement,
  8: ConfigTimeElement,
  12: ConfigBooleanElement,
  boolean: ConfigBooleanElement,
  configuration_list: ConfigListElement,
  custom_list: ConfigListElement,
  date: ConfigDateElement,
  list: ConfigListElement,
  multi_list: ConfigMultiListElement,
  number: ConfigNumberElement,
  tags: ConfigTagInputElement,
  text: ConfigTextElement,
  time: ConfigTimeElement
}

export {
  ConfigBooleanElement,
  ConfigDateElement,
  ConfigListElement,
  ConfigMultiListElement,
  ConfigNumberElement,
  ConfigTagInputElement,
  ConfigTextElement,
  ConfigTimeElement
}
